import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69401a0ee534c9001439dd0a/co_work_financial_partners/node_modules/next/dist/client/link.js");
